<nz-modal [nzTitle]="title" [(nzVisible)]="visible" (nzOnCancel)="visible=false" [nzWidth]="800" nzDraggable>
  <ng-template #title>
    LHDN Document Details
    <nz-tag *ngIf="data.isLive===true" [nzColor]="'success'">Production</nz-tag>
    <nz-tag *ngIf="data.isLive===false">Sandbox</nz-tag>
  </ng-template>
  <ng-container *nzModalContent>
    <nz-spin [nzSpinning]="loading">
      <nz-tabset [(nzSelectedIndex)]="activeTab" [nzSize]="'small'">
        <nz-tab [nzTitle]="'Details'"></nz-tab>
        <nz-tab [nzTitle]="'Validation Results'"></nz-tab>
        <nz-tab [nzTitle]="'QR Code'"></nz-tab>
        <nz-tab [nzTitle]="'Document'" *ngIf="data.document"></nz-tab>
      </nz-tabset>
      <sv-container col="2" *ngIf="activeTab === 0" labelWidth="110">
        <sv label="UUID" col="1">
          {{data.uuid}}
        </sv>
        <sv label="Submission ID" col="1">
          {{data.submissionUUID}}
        </sv>
        <sv label="Type Name">
          {{data.typeName}}
        </sv>
        <sv label="Internal Id">
          {{data.internalId}}
        </sv>
        <sv label="Issued Time">
          {{data.dateTimeIssued|date:'dd/MM/yyyy'}}
        </sv>
        <sv label="Status"
          [type]="data.status === 'Valid' ? 'success' : (data.status === 'Invalid' ? 'danger' : 'primary')">
          {{data.status}}
        </sv>
        <sv label="Issuer" col="1">
          {{data.issuerTin}} - {{data.issuerName}}
        </sv>
        <sv label="Receiver" col="1">
          {{data.receiverId}} - {{data.receiverName}}
        </sv>
        <sv label="Received Time">
          {{data.dateTimeReceived|date:'dd/MM/yyyy h:mm:ss a'}}
        </sv>
        <sv label="Validated Time">
          {{data.dateTimeValidated|date:'dd/MM/yyyy h:mm:ss a'}}
        </sv>
        <sv label="Total Discount">
          {{data.totalDiscount|currency:data.currencyCode:true}}
        </sv>
        <sv label="Net Amount">
          {{data.totalPayableAmount|currency:data.currencyCode:true}}
        </sv>
        <sv label="Cancel Time">
          {{data.cancelDateTime|date:'dd/MM/yyyy h:mm:ss a'}}
        </sv>
        <sv label="Reject Time">
          {{data.rejectRequestDateTime|date:'dd/MM/yyyy h:mm:ss a'}}
        </sv>
        <sv label="Status Reason" col="1">
          {{data.documentStatusReason}}
        </sv>
      </sv-container>
      <nz-table #errorsTable [nzData]="data.validationErrors" *ngIf="activeTab === 1" [nzSize]="'small'"
        [nzShowPagination]="false" [nzScroll]="{x: '600px'}">
        <thead>
          <tr>
            <th nzWidth="120px">Property</th>
            <th nzWidth="300px">Error</th>
            <th>Path</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let prop of errorsTable.data">
            <td [nz-tooltip]="prop.propertyPath">{{ prop.propertyName }}</td>
            <td>{{ prop.error }}</td>
            <td>{{ prop.propertyPath }}</td>
          </tr>
        </tbody>
      </nz-table>
      <ng-container *ngIf="activeTab === 3">
        <textarea title="Document" nz-input class="bg-grey-light" readonly [value]="data.document" #xml (focus)="xml.select()"
          [rows]="20"></textarea>
        <!-- <pre class="bg-grey-light" nz-typography nzCopyable="true" [nzContent]="data.document">{{data.document}}</pre> -->
      </ng-container>
      <ng-container *ngIf="activeTab === 2">
        <div class="text-center">
          <qrcode *ngIf="url" [qrdata]="url" [width]="150" [errorCorrectionLevel]="'M'" [margin]="0"
            [imageSrc]="'./assets/img/lhdn.jpg'" [imageHeight]="30" [imageWidth]="40"></qrcode>
          <nz-divider class="m-none"></nz-divider>
          <div class="text-center">
            <a [href]="url" target="_blank">E-Invoice</a>
          </div>
        </div>
      </ng-container>
    </nz-spin>
  </ng-container>
  <ng-container *nzModalFooter>
    <button type="button" nz-button (click)="visible=false">OK</button>
  </ng-container>
</nz-modal>
